// removed by extract-text-webpack-plugin
module.exports = {"spectrum":"DO1b8ZUOw4_K_Ipd68vBV","active":"_2r3XAEAp8R88fRqIXoDseq"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Spectrum/Spectrum.scss
// module id = 1322
// module chunks = 1